
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/en/claims",
      function () {
        return require("private-next-pages/de/en/claims.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/en/claims"])
      });
    }
  